<template>
    <section class="operator-offer-overview">
        <ScrollableView class="item-categories" v-if="!offer.isLoading && offer.hasItemCategories">
            <OfferItemCategoriesList :useCustomColor="true" @categorySelected="onItemsCategorySelected" />
        </ScrollableView>
        <ScrollableView
            ref="itemsContainer"
            class="offer-items-section"
            v-if="!offer.isLoading && offer.hasItemCategories"
        >
            <section class="items-container">
                <OfferItemTile
                    v-for="item in offer.offerItems"
                    :key="item.articleId"
                    :item="item"
                    :isAvailable="isItemAvailable(item)"
                    @addToCartPopoverClick="selectItem(item)"
                    @quickAddClick="quickAddItem(item)"
                />
            </section>
        </ScrollableView>
        <div class="no-active-offer-msg" v-if="!offer.isLoading && !offer.hasItemCategories">
            <span>{{ translations.offerSection.noActiveOffer }}</span>
        </div>
        <div class="offer-loader-container" v-if="offer.isLoading">
            <span>{{ translations.offerSection.loadingData }}</span>
        </div>
    </section>
</template>

<script setup lang="ts">
    import type { ICustomerArticleWithOptions } from "@/data/model/Customer";
    import { useOfferStore } from "@/data/stores/offer";
    import { translations } from "@/shared/localization/translations";
    import { ref } from "vue";

    import ScrollableView from "@/components/layout/ScrollableView.vue";
    import OfferItemCategoriesList from "@/components/offer/OfferItemCategoriesList.vue";
    import OfferItemTile from "@/components/offer/OfferItemTile.vue";

    const offer = useOfferStore();

    const emit = defineEmits<{
        addToCartPopoverClick: [article: ICustomerArticleWithOptions];
        quickAddClick: [article: ICustomerArticleWithOptions];
    }>();

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function isItemAvailable(item: ICustomerArticleWithOptions) {
        return true;
    }

    function selectItem(item: ICustomerArticleWithOptions) {
        emit("addToCartPopoverClick", item);
    }

    function quickAddItem(item: ICustomerArticleWithOptions) {
        emit("quickAddClick", item);
    }

    const itemsContainer = ref<InstanceType<typeof ScrollableView> | null>(null);
    function onItemsCategorySelected() {
        itemsContainer.value?.scrollToTop();
    }
</script>

<style scoped lang="scss">
    @use "./../../../../assets/styles/scss/shared/_colors.scss";

    .operator-offer-overview {
        font-size: 14px;
        position: absolute;
        top: 53px;
        right: 0;
        bottom: 104px;
        left: 0;
        box-sizing: border-box;
        display: flex;

        * {
            box-sizing: border-box;
        }

        .item-categories {
            flex: 0 0 auto;
            background-color: colors.$lightGreyBackground;
            border-right: 1px solid colors.$greyBorder;
            position: relative;

            min-width: 85px;
            width: 25%;
            max-width: 170px;

            font-size: 12px;
        }

        .offer-items-section {
            flex: 1 1 auto;

            .items-container {
                flex: 1 1 auto;
                display: flex;
                flex-wrap: wrap;
                align-content: flex-start;
                justify-content: space-between;
                padding: 3%;

                .offer-item-tile {
                    flex: 0 0 48%;
                    margin-bottom: 3%;
                    max-width: 48%;
                    min-width: 85px;

                    font-size: 15px;
                }
            }

            &.is-preorder-offer {
                margin-top: -36px;
            }
        }

        .no-active-offer-msg,
        .offer-loader-container {
            flex: 1 1 auto;
            display: flex;
            justify-content: center;
            align-items: center;
            background: #f5f5f5;

            span {
                color: colors.$fontColorHover;
                font-size: 20px;
            }
        }
    }
</style>
